import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDate, NuInput } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import MultiSelect from '../../../../Components/Utils/MultiSelect';
import { useToast } from '../../../../Components/Others/ToastServices';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import CloseIcon from '../../../../Components/Icons/Close';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import Video from '../../../../Components/Icons/Video';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import axiosInstance from '../../../../Services/axiosCommon';

function EditSchedule() {
    const { scheduleEditId } = useParams();
  
  const navigate = useNavigate();
     const location = useLocation();
     const edata = location?.state?.data;
     const [data,setData] = useState(edata? edata:null); 
 console.log(data,"edit");
 const [createNew, setCreateNew] = useState({
     
  contractId: data?.contractId  || "",
  location: data?.location  || "",
  description: data?.description  || "",
   date: data?.date  || "",
  status: data?.status  || "",
  assignees: data?.assignees?.map(item => item.assignee) || [],
 filesToRemove:[]
});
  

  function getView() {
    axiosInstance 
      .get(`/schedules/${scheduleEditId}`)
      .then((res) => {
        // console.log(res.data?.data,"res.data?.data");
        
        setCreateNew({
          contractId: res.data?.data?.contractId  || "",
  location: res.data?.data?.location  || "",
  description: res.data?.data?.description  || "",
   date: res.data?.data?.date  || "",
  status: res.data?.data?.status  || "",
  assignees: res.data?.data?.assignees?.map(item => Number(item.assignee)) || [],
 filesToRemove:[]
        });    
        // setCreateNew({...data,assignees:data?.assignees?.map(item => item.assignee) || []});       

      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    if (!edata) {
      getView();
    }
  }, [scheduleEditId])

     const { value: inspectionType,getData:refinspectionType } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Inspection_Type_Contracts"
    ); 
    const { value: scheduleType,getData:refscheduleType } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Schedule_Type_Schedule"
    ); 
    const { value: status,getData:refstatus } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Status_Schedule"
    );  

           const { data: user } = UseDropDown(`/user/drop-down`);
    
    
          const { data: contract } = UseDropDown(`/contract/drop-down`);
    
     
   const from = location.state?.from;
 
   const {  editFormData } =
     useEditFormData
     (); 
     
   console.log(data?.description,"newedit");

     const [filePathList, setFilePathList] = useState([]);
           const [fileRemoveList, setFileRemoveList] = useState([]);
          const [image, setImage] = useState([]);
           const toast = useToast();
           const [removefilePathList, setRemoveFilePathList] = useState([]);
         const [isModalOpen, setIsModalOpen] = useState(false);
           const [selectedImage, setSelectedImage] = useState(null);
           const [fileExtention, setFileExtention] = useState("");
        const [selectedFile, setSelectedFile] = useState(null);
      
        function handleImageChange(e) {
           const maxFileSize = 200000000; // 200 MB
           const files = Array.from(e.target.files);
           let fileArr = [];
           files.map((item) => {
             if (item.size < maxFileSize) {
               fileArr.push(item);
             } else {
               toast.open({
                 type: "warning",
                 message: `File Size to big`,
                 description: `${item.name} is Removed and not Uploaded`,
                 // placement: "bottomRight",
               });
             }
           });
           let tempArr = [];
           setSelectedFile(fileArr);
           files.map((item) => {
             if (item.size < maxFileSize) {
               let fileName = item?.name;
               console.log("fname", fileName);
               // let fileExtention = fileName.split(".").reverse()[0];
               // if (filetype?.includes(fileExtention)) {
               tempArr.push(fileName);
               // } else {
               //   let x = URL.createObjectURL(item);
               //   tempArr.push(x);
               // }
             }
           });
           console.log(tempArr, "temp");
           setImage(tempArr);
         }
       
         useEffect(() => {
           if (
             data?.attachments !== null &&
             data?.attachments !== "None" &&
             data?.attachments !== "[]"
           ) {
             // console.log(data.attachments, "ghjkllgd");
             setFilePathList(data?.attachments);
       
             setRemoveFilePathList(data?.attachments);
           }
         }, [data]);
       
         function UpdateAttachmentList(item) {
           let filterList = filePathList.filter((itemList) => itemList.file !== item);
           let removeFile = filePathList.find((itemList) => itemList.file === item);
           console.log("llll", filterList);
           setFileRemoveList([...fileRemoveList, removeFile.file]);
           setFilePathList(filterList);
         }
         function handleImageClick(img) {
           let Ext = img?.file_name.split(".").reverse()[0];
           setSelectedImage(img);
           setFileExtention(Ext);
           setIsModalOpen(true);
         }

         const removeImages = (value) => {
          console.log("value", value);
          let List = selectedFile.filter((item) => item?.name !== value);
          console.log("LIst", List);
          setSelectedFile([...List]);
          let tempArr = [];
          List.map((item) => {
            let fileName = item?.name;
            // console.log('fname',fileName);
            // let fileExtention =  fileName.split(".").reverse()[0]
            // if(filetype?.includes(fileExtention)){
            tempArr.push(fileName);
            // }else{
            //   let x = URL.createObjectURL(item)
            //   tempArr.push(x)
            // }
          });
          setImage(tempArr);
        };

   const formik = useFormik({
     enableReinitialize: true,
     initialValues: createNew,
     validateOnChange: false,
     validateOnBlur: false,
     validationSchema: yup.object({
                  contractId: yup.string().required("Contract is required!"),
                  assignees: yup
                  .array()
                  .of(yup.number())
                  .min(1, "Assignee is required!")
                  .required("Assignee is required!"),
                
      
           }),
     onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
       
        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
       editFormData(
         `/schedules/edit-schedule/${scheduleEditId}`,
         formData,
         resetForm,
         from,
       );},
       
   });
  
  
 
   return (
     <div className=" w-full h-full py-2 px-4 ">
          <div className="flex justify-between w-full ">      
          <Breadcrumb
                            items={[
                                  {
                                name: "Schedule",
                                link:"/inspection/schedule"         
                               
                              },
                  
                              { name: "Edit" },
                            ]}
                          /> 
         <BackButton />
       </div>
       <form onSubmit={formik.handleSubmit}>
         <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
         <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
         <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Inspection Schedule :
              </p>
            </div>
           

            <NuInput
                          type="text"
                          label="Description"
                          placeholder="Description"
                          formik={formik}
                          name="description"
                          width="w-full md:w-1/2 lg:w-2/3 "
                        />

<FormikSelectTwo
              label="Contract "
              Options={contract}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              isRequired={true}
              disabled={true}

              width="w-full md:w-1/2 lg:w-1/3"
            />

<MultiSelect
              label="Assignee"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignees"
              isRequired={true}

              width="w-full md:w-1/3"
            />
            <NuInput
                          type="text"
                          label="Location"
                          placeholder="Location"
                          formik={formik}
                          name="location"
                          width="w-full md:w-1/3"
                        />
<NuDate
              label="Date"
              placeholder="Date"
              formik={formik}
              name="date"
             
              width="w-full md:w-1/3 "
            />
           
           
           
           
            
           <DropDownAddMetaData
                            label="Status"
                            placeholder="Choose"
                            Options={status}
                            formik={formik}
                            name="status"
                            width="w-full md:w-1/3 md:-mt-1 "
                            getFunc={refstatus}
                            displayProperty={"Status"}
                            propertyName={"Status_Schedule"}
                            FixPosition={false}
                            PortalTarget={false}
              
                          />
              <div className="w-full">
                            <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                               Attachement :
                            </p>
                            <Attachement
                                            handleChange={handleImageChange}
                                            preview={image || ""}
                                            width="w-full"
                                            label="Attach"
                                            multiple={true}
                                            removeImages={removeImages}
                                          />
                          </div>
                          <div className="md:flex justify-between mt-5 px-3 w-full">
                            <div className="w-full flex gap-2 items-center flex-wrap">
                              {data?.attachments &&
                                filePathList?.map((imgs, idx) => {
                                  console.log("img", imgs);
                                  let Ext = imgs?.file_name.split(".").reverse()[0];
                                  return (
                                    <div
                                      className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                                      key={idx}
                                      style={{
                                        border: "1px solid gray",
                                        borderColor:
                                          "rgb(148 163 184 / var(--tw-bg-opacity))",
                                      }}
                                    >
                                      <div
                                        className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                                        onClick={() => UpdateAttachmentList(imgs?.file)}
                                      >
                                        <CloseIcon color="white" height="8" width="8" />
                                      </div>
                                      <div
                                        className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                                        onClick={() => handleImageClick(imgs)}
                                      >
                                        <div className=" w-8 h-8">
                                          {videotype.includes(Ext) ? <Video /> : null}
            
                                          {Ext === ("docx" || "doc" || "txt") ? (
                                            <Doc />
                                          ) : Ext === ("xlsx" || "xls") ? (
                                            <Xls />
                                          ) : Ext === "txt" ? (
                                            <Txt />
                                          ) : Ext === "pdf" ? (
                                            <Pdf />
                                          ) : Ext === "PDF" ? (
                                            <Pdf />
                                          ) : Ext === "pptx" ? (
                                            <>No file</>
                                          ) : (
                                            <img src={imgs?.file} alt="#" width="120%" />
                                          )}
                                        </div>
                                        <p className=" w-[50px] text-[11px] truncate">
                                          {imgs?.file_name}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
            
                            </div>
                          </div>
            
             <div className="w-full  my-4 mt-8 ">
               <div className=" flex justify-end gap-4">
                 <CancelButton
                   handleClick={() => {
                     navigate(-1);
                   }}
                 />
                 <SubmitButton />
               </div>
             </div>
           </div>
         </div>
       </form>
     </div>
   );
 }
 

export default EditSchedule
